export function refineNumberFormat (number) {
  if (isGreaterThan(1000, number)) {
    return `${commaDelimitNumber(roundToNearest(1000, number))}+`
  } else if (isGreaterThan(100, number)) {
    return `${commaDelimitNumber(roundToNearest(100, number))}+`
  } else {
    return number
  }
}

function isGreaterThan (limit, number) {
  return number > limit
}

function commaDelimitNumber (number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

function roundToNearest (limit, number) {
  return Math.floor(number / limit) * limit
}
